module.exports = __webpack_public_path__ + "img/people.0c6397ff.png";